export default (theme) => {
  return ``;
};



// WEBPACK FOOTER //
// ./src/muse-ui/GridList/theme.js